/* eslint-disable react/jsx-one-expression-per-line */
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button as ButtonC } from '@codex/basics';

import { BottomButtonsWarning, FilterBottomButtons } from '../styled';

const Button = styled(ButtonC)`
  margin: 15px 18px;
`;

export default function FiltersMobileButtons({
  showWarningMessage,
  showErrorMessage,
  resetButtonDisabled,
  onResetButtonClick,
  resetButtonLabel,
  applyButtonDisabled,
  onApplyButtonClick,
  applyButtonLabel
}) {
  const buttonsClassNames = ['dc-filter__bottom-buttons', 'dc-filter__bottom-buttons--sticky'];

  return (
    <>
      {showWarningMessage && (
        <BottomButtonsWarning className={'dc-filter__bottom-buttons--warning'}>
          <b>0 results</b> - Please remove some of your filters
          {/* TODO: add to translations */}
        </BottomButtonsWarning>
      )}
      {showErrorMessage && (
        <BottomButtonsWarning className={'dc-filter__bottom-buttons--warning'}>
          {"Sorry, we can't apply filters just now. Please try later."}{' '}
          {/* TODO: add to translations */}
        </BottomButtonsWarning>
      )}
      <FilterBottomButtons className={buttonsClassNames.join(' ')}>
        <Button disabled={resetButtonDisabled} onClick={onResetButtonClick}>
          {resetButtonLabel}
        </Button>
        <Button positive disabled={applyButtonDisabled} onClick={onApplyButtonClick}>
          {applyButtonLabel}
        </Button>
      </FilterBottomButtons>
    </>
  );
}

FiltersMobileButtons.displayName = 'FiltersMobileButtons';

FiltersMobileButtons.propTypes = {
  resetButtonDisabled: PropTypes.bool,
  applyButtonDisabled: PropTypes.bool,
  resetButtonLabel: PropTypes.string,
  applyButtonLabel: PropTypes.string,
  showWarningMessage: PropTypes.bool,
  showErrorMessage: PropTypes.bool,
  onResetButtonClick: PropTypes.func,
  onApplyButtonClick: PropTypes.func
};

FiltersMobileButtons.defaultProps = {
  resetButtonDisabled: false,
  applyButtonDisabled: false,
  resetButtonLabel: 'Reset',
  applyButtonLabel: 'Apply',
  showErrorMessage: false,
  showWarningMessage: false,
  onResetButtonClick: () => {},
  onApplyButtonClick: () => {}
};
